import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Usuario } from "../models/usuario.model";
import { environment } from "src/environments/environment";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class UsuarioRestService {
  constructor(private httpClient: HttpClient) {}

  obtenerDatosUsuarioIdentificado(): Observable<Usuario> {
    return this.httpClient.get<Usuario>(
      environment.apiURL + "v1/usuarios/actual"
    );
  }

  comprobarSiUsuarioIdentificadoEsSolicitante() {
    this.httpClient.post(
      environment.apiURL + "v1/tramites/guardar", {}
    );
    return this.httpClient.get<boolean>(
      environment.apiURL + "v1/usuarios/actual/estado/solicitante"
    );

  }
}
